// extracted by mini-css-extract-plugin
export default {"space90":"index_space90_M-TnP","footcolumn":"index_footcolumn_ILqdY"};